import { ArrowButton, Label } from "@king-ict/eupisi-ui/components";

import { CommitteeEmployee } from "../../../../models/Committee";
import {
  CommitteeDecision,
  CommitteeEnrollmentDecision,
} from "../../../../models/Request";
import { FormatUtils, MsgUtils } from "../../../../utils";
import { findDecisionForCommittee } from "./committee-operations.util";

export const renderActionButton = (ariaLabel: string, onClick: () => void) => {
  return (
    <div className="text-right">
      <ArrowButton ariaLabel={ariaLabel} onClick={onClick} />
    </div>
  );
};

export const renderEnrollmentDecision = (
  committee: CommitteeEmployee,
  committeeDecisions: CommitteeDecision[]
) => {
  const decision = findDecisionForCommittee(committee, committeeDecisions);
  if (!decision?.committeeEnrollmentDecisionId) return null;

  const decisionColor = FormatUtils.getCommitteeEnrollmentDecisionColor(
    decision.committeeEnrollmentDecisionId
  );

  const decisionName = MsgUtils.getEnumToCodeBook(
    CommitteeEnrollmentDecision,
    "committeeEnrollmentDecision"
  ).find((v) => v.id === decision.committeeEnrollmentDecisionId)?.name;

  return (
    <Label
      color={decisionColor}
      className="text-center"
      outline={false}
      fullWidth={false}
    >
      {decisionName}
    </Label>
  );
};
